import Cookies from 'universal-cookie';

/**
 * The `_2fa_link_token` cookie backs the 2FA email-link flow. The login page
 * sets it when the backend asks for a 2FA email link, reads it when validating
 * the link, and clears it afterwards — ported from the Ember `auth-cookies`
 * util (the backend authenticator just forwards the value).
 */
export const TWO_FACTOR_LINK_TOKEN = '_2fa_link_token';

// 15 minutes, matching the Ember cookie lifetime.
const MAX_AGE_SECONDS = 15 * 60;

const cookies = new Cookies();

export function getTwoFactorAuthLinkCookie(): string | undefined {
  return cookies.get(TWO_FACTOR_LINK_TOKEN);
}

export function setTwoFactorAuthLinkCookie(token: string): void {
  cookies.set(TWO_FACTOR_LINK_TOKEN, token, {
    path: '/',
    maxAge: MAX_AGE_SECONDS,
    sameSite: 'strict',
    secure: __CIO_ENV__ !== 'development',
  });
}

export function removeTwoFactorAuthLinkCookie(): void {
  cookies.remove(TWO_FACTOR_LINK_TOKEN, { path: '/' });
}
